import type {
  CareBookingInitData,
  ServiceBookingInitData,
} from 'interfaces/types/QuickBooking'

export enum QuickBookingType {
  DOCTOR,
  SERVICE,
}

export type QuickBookingStoreType = {
  openQuickBookingDrawer: boolean
  setOpenQuickBookingDrawer(isOpen: boolean): void
  careType: QuickBookingType
  setCareType(careType: QuickBookingType): void
  data?: CareBookingInitData | ServiceBookingInitData
  setData(data: CareBookingInitData | ServiceBookingInitData): void
}
